import styled from 'styled-components'

export const RoundedWrapper = styled.div.attrs({
  className: 'col-12 mt-3',
})`
  flex: 1;
  border: 1px solid rgb(0, 0, 0);
  border-radius: 6px;
  margin-right: ${({ gap }) => gap || 0};
  margin-bottom: 20px;
`

export const MainWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

export const LevelRowContainer = styled.div.attrs(({ className }) => ({
  className: `${className || 'col-12 mx-0'}`,
}))`
  padding: 7px 0;

  @media (min-width: 700px) {
    display: flex;
    flex-wrap: wrap;
  }
`

export const FieldWrapper = styled.div`
  padding: 0px 5px 0px 5px;
`

export const ButtonAdd = styled.img`
  height: 40px;
  width: 40px;
  margin-bottom: 20px;

  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`

export const File = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 10px;
`

export const HeadContainer = styled.div`
  padding: 16px 0px;
  display: flex;
  flex-direction: row;
  align-content: center;
  border-bottom: 1px solid #e0e0e0;
`

export const InputCol = styled.div`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: column;
  margin-right: 5px;
  margin-left: 5px;
`

export const Title = styled.p`
  font-size: 18px;
  font-weight: bold;
  margin: 0;
`

export const ModalFooter = styled.div`
  margin-top: auto;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-self: flex-center;
`

export const ModalHead = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
`

export const ButtonSpace = styled.div`
  margin: 0px 5px 5px 0px;
`

export const ModalWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

export const ModalBody = styled.div`
  height: 490px;
  overflow: auto;
`

export const AttachmentsContainer = styled.div`
  max-height: 100px;
  overflow: auto
`
